module.exports = {
      id: "comm-video-usage",
      viewBox: "0 0 276.069 41.984",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-video",
      toString: function () {
        return this.url;
      }
    }